


















































































































































































































































import {Component, Vue} from "vue-property-decorator";
import {KsChatUser} from "@/entity/KsChatUser";
import {KsGroup} from "@/entity/KsGroup";
import {XmppUtils} from "@/xmpp/XmppUtils";
import {KsChatUserDto} from "@/dto/KsChatUserDto";
import {SecurityUtils} from "@/oauth/SecurityUtils";
import {Friend} from "@/entity/Friend";
import {Response} from "@/entity/Response";
import {KsManager} from "@/entity/KsManager";

@Component({
  components: {},
})

export default class GroupDetails extends Vue {
  groupId = this.$route.params.id;
  ksChatUser: KsChatUser[] = [];
  ksGroup = new KsGroup();
  addGroupMemberDialog = false;
  friends: Friend[] = [];
  friends1: Friend[] = [];
  su = SecurityUtils;
  friendName = '';
  removeFriendName = '';
  removeGroupMemberDialog = false;
  addGroupAdminDialog = false;
  removeGroupAdminDialog = false;
  ksManagers: KsManager[] = [];

  async addGroupAdmin() {
    const ksManager = new KsManager();
    ksManager.groupId = this.groupId as unknown as number;
    ksManager.type = 1;
    for (const value of this.ksChatUser) {
      if (value.isSelect) {
        ksManager.managerId = value.userId;
        ksManager.managerName = value.userName;
        const response = await KsChatUserDto.updateksmanger(ksManager);
        if (response.code == 200) {
          this.$q.notify({message: '添加成功', color: 'green', timeout: 1000})
        }
        this.addGroupMemberDialog = false;
      }
    }
  }

  async removeGroupAdmin() {
    for (const value of this.ksManagers) {
      if (value.isSelect) {
        const response = await KsChatUserDto.deleteksmanger(value);
        if (response.code == 200) {
          let i = 0;
          for (i; i < this.ksManagers.length; i++) {
            if (this.ksManagers[i].managerId == value.managerId) {
              this.ksManagers.splice(i, 1);
            }
          }
          this.$q.notify({message: '删除成功', color: 'green', timeout: 1000})
        } else {
          this.$q.notify({message: response.msg, color: 'red', timeout: 1000})
        }
        this.removeGroupMemberDialog = false;
      }
    }
  }

  async deleteGroup() {
    const response = await KsChatUserDto.deleteKsGroup(this.groupId as unknown as number);
    if (response.code == 200) {
      this.$q.notify({message: '删除成功', color: 'green', timeout: 1000})
    }
    for (let i = 0; i < XmppUtils.groups.length; i++) {
      if (XmppUtils.groups[i].id == this.groupId) {
        XmppUtils.groups.splice(i, 1);
      }
    }
    await this.$router.push({name: 'keShangSelect2'});
  }

  async addGroupMember() {
    const ksChatUser1 = new KsChatUser();
    ksChatUser1.groupId = this.groupId;
    ksChatUser1.groupName = this.ksGroup.groupName;
    ksChatUser1.roomName = this.ksGroup.roomName;
    for (const value of this.friends1) {
      if (value.isSelect) {
        ksChatUser1.userId = value.jid.substring(0, 11);
        ksChatUser1.userName = value.name;
        ksChatUser1.userAvatarUrl = value.avatarUrl;
        ksChatUser1.isSelect = false;
        const response = await KsChatUserDto.insertchatuser(ksChatUser1);
        if (response.code == 200) {
          this.ksChatUser.push(ksChatUser1);
          this.$q.notify({message: '添加成功', color: 'green', timeout: 1000})
        }
        this.addGroupMemberDialog = false;
      }
    }
  }

  async removeGroupMember() {
    for (const value of this.ksChatUser) {
      if (value.isSelect) {
        value.baseId = this.su.getLoginUser().username;
        const response = await KsChatUserDto.deletechatuser(value);
        if (response.code == 200) {
          let i = 0;
          for (i; i < this.ksChatUser.length; i++) {
            if (this.ksChatUser[i].userId == value.userId) {
              this.ksChatUser.splice(i, 1);
            }
          }
          this.$q.notify({message: '删除成功', color: 'green', timeout: 1000})
        } else {
          this.$q.notify({message: response.msg, color: 'red', timeout: 1000})
        }
        this.removeGroupMemberDialog = false;
      }
    }
  }

  async searchRemoveFriend() {
    this.ksChatUser = [];
    this.ksChatUser = await KsChatUserDto.getallUserBygroupId(this.groupId);
    this.ksChatUser.forEach(value => value.isSelect = false);
    if (this.removeFriendName == '') {
      return;
    } else {
      const ksChatUser = this.ksChatUser.filter(v => v.userName.toLowerCase().indexOf(this.removeFriendName) > -1);
      this.ksChatUser = ksChatUser;
    }
  }

  async searchFriend() {
    this.friends1 = [];
    await this.unGroupMemberFriends();
    if (this.friendName == '') {
      return;
    } else {
      const friends = this.friends1.filter(v => v.name.toLowerCase().indexOf(this.friendName) > -1);
      this.friends1 = friends;
    }
  }

  async unGroupMemberFriends() {
    this.friends = [];
    this.friends1 = [];
    XmppUtils.friends.forEach(value => {
      this.friends.push(value);
      this.friends1.push(value);
    });
    for (let i = 0; i < this.friends.length; i++) {
      for (let j = 0; j < this.ksChatUser.length; j++) {
        if (this.friends[i].jid.substring(0, 11) == this.ksChatUser[j].userId) {
          // this.friends.splice(i, 1);
          this.friends1.splice(i, 1);
        }

      }
    }
    this.friends1.forEach(value => value.isSelect = false);
  }

  async mounted() {
    const ksChatUser = await KsChatUserDto.getallUserBygroupId(this.groupId);
    ksChatUser.forEach(value => {
          value.isSelect = false;
          this.ksChatUser.push(value);
        }
    )
    this.ksGroup = await KsChatUserDto.getksgroup(this.groupId);
    this.ksChatUser.forEach(value => {
      // value.isSelect = false;
      XmppUtils.friends.forEach(value1 => {
        if (value.userId == value1.jid.substring(0, 11)) {
          value.userAvatarUrl = value1.avatarUrl;
        }
        if (value.userId == this.su.getLoginUser().username) {
          value.userAvatarUrl = this.su.getLoginUser().avatarUrl;
        }
      })
    });
    await this.unGroupMemberFriends();
    this.ksManagers = await KsChatUserDto.getmanagermessage(this.groupId);
  }

}
